<template>
    <div class="ah-page staff-roles-edit-page">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>身份功能編輯</h1>
                    </div>
                    <div class="actions">
                        <el-button plain type="dark" @click="submitDelete" :loading="isSubmitting" v-if="form.grP_NO && !isQR()">刪除</el-button>
                        <el-button plain type="primary" @click="goBackToList" :loading="isSubmitting">取消</el-button>
                        <el-button v-if="!isQR()" plain type="primary" @click="submitForm" :loading="isSubmitting">
                            <span v-if="form.grP_NO">儲存</span>
                            <span v-if="!form.grP_NO">新增</span>
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <el-form ref="form" :model="form" :rules="rules" label-width="180px" label-position="right">
                <div class="ah-panel">
                    <div class="panel-header small gray">
                        <div class="panel-title">身份設定</div>
                    </div>
                    <div class="panel-body">
                        <el-form-item label="名稱" prop="grP_NAM">
                            <el-input v-model="form.grP_NAM" style="max-width: 300px"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="ah-panel">
                    <div class="panel-header small gray">
                        <div class="panel-title">預設功能設定</div>
                    </div>
                    <div class="panel-body">
                        <el-alert type="warning" :closable="false" v-if="isExists" style="margin-bottom: 20px;">提醒您：下方功能變更後，不影響已是該身份的使用者功能。</el-alert>
                        <ah-authority-table v-model="form.untList" />
                    </div>
                </div>
            </el-form>
        </div>
        <div style="text-align: center;">
            <el-button @click="goBackToList" :loading="isSubmitting">取消</el-button>
            <el-button v-if="!isQR()" type="primary" class="primary-btn" @click="submitForm" style="width: 150px" :loading="isSubmitting">
                <span v-if="form.grP_NO">儲存</span>
                <span v-if="!form.grP_NO">新增</span>
            </el-button>
        </div>
    </div>
</template>
<script>
import ahAuthorityTable from '@/components/ui/ahAuthorityTable';

export default {
    name: 'staff-roles-edit-page',
    components: {
        ahAuthorityTable,
    },
    data() {
        return {
            isLoading: false,
            isSubmitting: false,
            form: {
                grP_NAM: null,
                grP_NO: null,
                untList: [],
            },
            rules: {
                grP_NAM: [{ required: true, message: '請輸入名稱', trigger: 'blur' }],
            },
        };
    },
    computed: {
        isExists() {
            return this.form.grP_NO != null;
        },
    },
    mounted() {
        this.fetchRoleData(this.$route.query.no);
    },
    methods: {
        fetchRoleData(grpno) {
            if (grpno) {
                this.isLoading = true;
                this.$api({
                    url: '/AccountManagement/GetRoleGroupDefaultMenuSettings',
                    params: {
                        GRP_NO: grpno,
                    },
                    method: 'GET',
                })
                    .then((resp) => {
                        console.log(resp.data);
                        this.form = resp.data;
                        this.form.grP_NO = grpno;
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            }
        },
        goBackToList() {
            this.$router.push({ name: 'staff-roles' });
        },
        submitForm() {
            // 表單驗證
            this.$refs.form.validate((valid) => {
                if (valid) {
                    const addApiUrl = '/AccountManagement/AddRoleGroupDefaultMenuSettings';
                    const updateApiUrl = '/AccountManagement/UpdateRoleGroupDefaultMenuSettings';

                    this.isSubmitting = true;
                    this.$api({
                        url: this.isExists ? updateApiUrl : addApiUrl,
                        data: this.form,
                        method: 'POST',
                    })
                        .then(() => {
                            this.goBackToList();
                        })
                        .finally(() => {
                            this.isSubmitting = false;
                        });
                }
            });
        },
        submitDelete() {
            this.$confirm('確定要刪除？', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
            }).then(() => {
                this.isSubmitting = true;
                this.$api({
                    url: '/AccountManagement/DeleteRoleGroup',
                    data: this.form,
                    method: 'POST',
                })
                    .then(() => {
                        this.goBackToList();
                    })
                    .finally(() => {
                        this.isSubmitting = false;
                    });
            });
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";

.staff-roles-edit-page {
}
</style>
